module.exports = __webpack_public_path__ + "static/turquia-016-3000eb010688405347c241ef498b9169.jpg";